"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalErrorBoundary = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
/**
 * Represents an internal error boundary component.
 *
 */
class InternalErrorBoundary extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      error: undefined,
      errorInfo: undefined
    });
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      logger
    } = this.props;
    this.setState({
      errorInfo
    });
    logger.error(new Error('ErrorBoundary', {
      cause: error
    }), {
      ...errorInfo
    });
  }
  render() {
    const {
      error,
      errorInfo
    } = this.state;
    const {
      children,
      fallback
    } = this.props;
    if (error) {
      if (typeof fallback === 'function') {
        return fallback({
          error,
          errorInfo
        }) ?? null;
      }
      return fallback ?? null;
    }
    return children;
  }
}
exports.InternalErrorBoundary = InternalErrorBoundary;
//# sourceMappingURL=InternalErrorBoundary.js.map